import React, { useContext, useEffect, useState } from "react";
import errorIcon from "../../images/errorRedIcon.png";
import successIcon from "../../images/successGreenIcon.png";
import LoadingIcon from "../../images/Loading_icon.gif";
import { UrlContext } from "../../contexts/UrlContext";

export default function AvailabilityComment({
  comment,
  expert_id,
  setAvailabilityComment,
  backupData,
  setBackupData,
  setShowComment,
}) {
  const [availComment, setAvailComment] = useState("");
  const [returnSuccess, setReturnSuccess] = useState(false);
  const [returnError, setReturnError] = useState(false);
  const [setTimeoutid, setSetTimeoutid] = useState(null);
  const [loading, setLoading] = useState(false);
  const commentRef = React.createRef();
  const { API_URL } = useContext(UrlContext);
  useEffect(() => {
    if (comment) {
      setAvailComment(comment);
    }
  }, [comment]);

  const handleUpdateComment = (newValue) => {
    setReturnError(false);
    setLoading(true);
    const expertData = {
      availComment: newValue,
      expert_id,
    };
    fetch(`${API_URL}change-availability-comment`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(expertData),
    })
      .then((res) => res.json())
      .then((data) => {
        setLoading(false);
        if (data.status === "success") {
          setReturnSuccess(true);
          clearTimeout(setTimeoutid);
          setSetTimeoutid(
            setTimeout(() => {
              setReturnSuccess(false);
            }, 1500)
          );
          setBackupData(
            backupData.map((item) => {
              if (item.id === expert_id) {
                item.available_comment = newValue;
              }
              return item;
            })
          );
        } else {
          setReturnError(true);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        setReturnError(true);
      });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (commentRef.current && !commentRef.current.contains(event.target)) {
        setTimeout(() => {
          setShowComment(false);
        }, 100);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [commentRef]);

  return (
    <div className="topCon-comment-div" ref={commentRef}>
      <textarea
        placeholder="Add availability comment"
        title="Availability comment"
        value={availComment}
        onChange={(e) => {
          setAvailComment(e.target.value);
          if (e.target.value === "") {
            setAvailabilityComment("");
          } else {
            setAvailabilityComment(e.target.value);
          }
        }}
        onBlur={(e) => handleUpdateComment(e.target.value)}
      />
      {loading && (
        <img
          className="return-msg-icon"
          style={{ top: "6px", left: "452px" }}
          src={LoadingIcon}
          alt="loading"
          title="Loading..."
        />
      )}
      {returnSuccess && (
        <img
          className="return-msg-icon"
          style={{ top: "6px", left: "452px" }}
          src={successIcon}
          alt="success"
          title="Success"
        />
      )}
      {returnError && (
        <img
          className="return-msg-icon"
          style={{ top: "6px", left: "452px" }}
          src={errorIcon}
          alt="error"
          title="Error! Please reload"
        />
      )}
    </div>
  );
}
